/**
 * Eli, 20 Oct 2026 (D-1020-EXTRA): a Move of an Extra support visit into a week that already has a visit is refused in words
 * (the same words as Book this spot). The administrator can still do it — a second press with a reason, kept with the visit.
 * Everyone else sees the words only. Nothing here sends anything by itself; the press does.
 */
import { useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/Icons';
import { Button } from '@/components/ui/button';

export function ExtraWeekOverride({ message, isAdmin, busy, onConfirm }: { message: string; isAdmin: boolean; busy: boolean; onConfirm: (reason: string) => void }) {
  const { t } = useTranslation();
  const id = useId();
  const [why, setWhy] = useState('');
  const ok = why.trim().length >= 3;
  return (
    <div className="warn take" role="alert" data-testid="move-week-block">
      <Icon name="alert" />
      <div>
        <b data-testid="move-week-message">{message}</b>
        {isAdmin ? (
          <div className="field">
            <label htmlFor={`${id}-why`}>{t('extra1020.why')}</label>
            <input id={`${id}-why`} className="input" value={why} maxLength={200} placeholder={t('extra1020.whyPlaceholder')} onChange={(e) => setWhy(e.target.value)} aria-describedby={`${id}-help`} aria-required="true" data-testid="move-week-why" />
            <p className="help" id={`${id}-help`}>
              {t('extra1020.moveAnywayHelp')}
            </p>
            <Button size="sm" type="button" disabled={!ok || busy} onClick={() => onConfirm(why.trim())} data-testid="move-week-override">
              {t('extra1020.moveAnyway')}
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
}
